import jiangxi from "@/mock/map/jiangxi";
import jiujiang from "@/mock/map/jiujiang";
import nanchang from "@/mock/map/nanchang";
import ganzhou from "@/mock/map/ganzhou";
import fuzhou from "@/mock/map/fuzhou";
import yingtan from "@/mock/map/yingtan";
import shangrao from "@/mock/map/shangrao";
import jingdezhen from "@/mock/map/jingdezhen";
import yichun from "@/mock/map/yichun";
import xinyu from "@/mock/map/xinyu";
import pingxiang from "@/mock/map/pingxiang";
import jian from "@/mock/map/jian";
import { removeEndingChars } from "@/utils/tool";
const geojsonDic = {
  九江市: jiujiang,
  南昌市: nanchang,
  赣州市: ganzhou,
  抚州市: fuzhou,
  鹰潭市: yingtan,
  上饶市: shangrao,
  景德镇市: jingdezhen,
  宜春市: yichun,
  新余市: xinyu,
  萍乡市: pingxiang,
  吉安市: jian
};
const DEFAULT_ADCODE = 360000;
const name = ref("江西");
const byname = computed(() => removeEndingChars(name.value));
const geojson = ref(jiangxi);
const level = ref(1);
const levelGeoJsonDic = ref({});
const levelNameDic = ref({});
const isMore = ref(true);
const adcode = computed(() => {
  const targetGeojson = levelGeoJsonDic.value[level.value - 1] || jiangxi;
  const targetItem = targetGeojson?.features.find(item => item.properties.name === name.value);
  // console.log("targetItem.name", targetItem?.properties?.name || name.value);
  return targetItem?.properties?.adcode || DEFAULT_ADCODE;
});
const setMapData = text => {
  // console.log("setMapData-isMore", isMore.value);
  // console.log("setMapData-level", level.value);
  if (!isMore.value) {
    return;
  }
  setLevel(1);
  name.value = text || "江西";
  if (geojsonDic[text]) {
    geojson.value = geojsonDic[text];
  } else {
    isMore.value = false;
    let data = geojson.value?.features?.find(item => item.properties.name === text);
    if (data) {
      geojson.value = {
        type: "FeatureCollection",
        features: [data]
      };
    }
  }
};
const setLevel = num => {
  if (num > 0) {
    levelGeoJsonDic.value[level.value] = geojson.value;
    levelNameDic.value[level.value] = name.value;
  }
  level.value += num;
  if (num < 0) {
    geojson.value = levelGeoJsonDic.value[level.value] || jiangxi;
    name.value = levelNameDic.value[level.value] || "江西";
  }
  if (level.value !== 3) {
    isMore.value = true;
  }
  console.group("setLevel");
  console.log("level", level.value);
  console.log("geojson", geojson.value);
  console.log("levelGeoJsonDic", levelGeoJsonDic.value);
  console.groupEnd("setLevel");
};
export const mapStore = () => {
  return {
    byname,
    name,
    geojson,
    level,
    setMapData,
    setLevel,
    adcode
  };
};